"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.streamfansTypography = exports.streamfansSpacing = exports.streamfansSharedColors = exports.streamfansIconSizes = exports.streamfansComponents = exports.isAlwaysNativeDropDownMenu = void 0;
var _AuthButton = _interopRequireDefault(require("./AuthButton.theme"));
var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup.theme"));
var _ButtonGroupItem = _interopRequireDefault(require("./ButtonGroupItem.theme"));
var _Checkbox = _interopRequireDefault(require("./Checkbox.theme"));
var _Chip = _interopRequireDefault(require("./Chip.theme"));
var _Dialog = _interopRequireDefault(require("./Dialog.theme"));
var _Drawer = _interopRequireDefault(require("./Drawer.theme"));
var _DropDownMenu = _interopRequireDefault(require("./DropDownMenu.theme"));
var _FlatButton = _interopRequireDefault(require("./FlatButton.theme"));
var _Form = _interopRequireDefault(require("./Form.theme"));
var _IconButton = _interopRequireDefault(require("./IconButton.theme"));
var _LiveBug = _interopRequireDefault(require("./LiveBug.theme"));
var _MessageBar = _interopRequireDefault(require("./MessageBar.theme"));
var _Modal = _interopRequireDefault(require("./Modal.theme"));
var _Nav = _interopRequireDefault(require("./Nav.theme"));
var _Paper = _interopRequireDefault(require("./Paper.theme"));
var _Popover = _interopRequireDefault(require("./Popover.theme"));
var _RadioButton = _interopRequireDefault(require("./RadioButton.theme"));
var _RaisedButton = _interopRequireDefault(require("./RaisedButton.theme"));
var _ReactionSelector = _interopRequireDefault(require("./ReactionSelector.theme"));
var _Select = _interopRequireDefault(require("./Select.theme"));
var _SideMenuSubmenu = _interopRequireDefault(require("./SideMenuSubmenu.theme"));
var _Slider = _interopRequireDefault(require("./Slider.theme"));
var _Snackbar = _interopRequireDefault(require("./Snackbar.theme"));
var _SvgIcon = _interopRequireDefault(require("./SvgIcon.theme"));
var _Tab = _interopRequireDefault(require("./Tab.theme"));
var _Table = _interopRequireDefault(require("./Table.theme"));
var _TableHeader = _interopRequireDefault(require("./TableHeader.theme"));
var _Tabs = _interopRequireDefault(require("./Tabs.theme"));
var _Tag = _interopRequireDefault(require("./Tag.theme"));
var _Text = _interopRequireDefault(require("./Text.theme"));
var _TextInput = _interopRequireDefault(require("./TextInput.theme"));
var _Toggle = _interopRequireDefault(require("./Toggle.theme"));
var _sharedThemeSettings = require("../../themes/sharedThemeSettings");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var streamfansSharedColors = exports.streamfansSharedColors = _objectSpread({
  primary: "#ff257b",
  primaryDark: "#d41862",
  alert: "#e02020",
  warning: "#cc7d00",
  success: "#00C853",
  info: "#757575",
  active: "#00C853",
  activeVariant: "#195b1e",
  textOnDark: "#ffffff",
  textOnLight: "#212121",
  baseInvariant: "#c7c7cc",
  baseShadow: "#000000",
  gold: "#ffc107",
  goldVariant: "#8f680a",
  goldGradient: "#ffc107",
  goldGradientHover: "#ffc107",
  messenger: "#0B84FF"
}, _sharedThemeSettings.brandColors);
var streamfansIconSizes = exports.streamfansIconSizes = {
  small: 20,
  medium: 24,
  large: 32
};
var streamfansSpacing = exports.streamfansSpacing = {
  base: 8
};

// to see how the fallback is loaded, check:
// https://stash.atg-corp.com/projects/SM/repos/streamfans.server
var streamfansTypography = exports.streamfansTypography = {
  fontFamily: "Roboto, Roboto_fallback, ".concat(_sharedThemeSettings.SANS_SERIF_BASE),
  fontSize: 14,
  fontWeight: 400,
  letterSpacing: 0.5,
  lineHeight: 1.45
};
var isAlwaysNativeDropDownMenu = exports.isAlwaysNativeDropDownMenu = true;
var streamfansComponents = exports.streamfansComponents = {
  AuthButton: _AuthButton.default,
  ButtonGroup: _ButtonGroup.default,
  ButtonGroupItem: _ButtonGroupItem.default,
  Checkbox: _Checkbox.default,
  Chip: _Chip.default,
  Dialog: _Dialog.default,
  Drawer: _Drawer.default,
  DropDownMenu: _DropDownMenu.default,
  FlatButton: _FlatButton.default,
  Form: _Form.default,
  IconButton: _IconButton.default,
  LiveBug: _LiveBug.default,
  MessageBar: _MessageBar.default,
  Modal: _Modal.default,
  Nav: _Nav.default,
  Paper: _Paper.default,
  Popover: _Popover.default,
  RadioButton: _RadioButton.default,
  RaisedButton: _RaisedButton.default,
  ReactionSelector: _ReactionSelector.default,
  Select: _Select.default,
  SideMenuSubmenu: _SideMenuSubmenu.default,
  Slider: _Slider.default,
  Snackbar: _Snackbar.default,
  SvgIcon: _SvgIcon.default,
  Tab: _Tab.default,
  Table: _Table.default,
  TableHeader: _TableHeader.default,
  Tabs: _Tabs.default,
  Tag: _Tag.default,
  Text: _Text.default,
  TextInput: _TextInput.default,
  Toggle: _Toggle.default
};